import { get } from "@insite/mobius/utilities";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";

export default (property: string, path: string, transform?: (x: any) => any) => (props: any) => {
    const value = get(props, path, null);

    return cssProp(property, transform ? transform(value) : value);
};
